import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PURCHASE_ORDER_RECEIPTS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('PURCHASE_ORDER_RECEIPTS');
export const PURCHASE_ORDER_RECEIPTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PURCHASE_ORDER_RECEIPTS_CRUD_ACTION_CONSTANTS
);
